import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import AuctionDetails from './AuctionDetailsForm';
import AddressForm from './AddressForm';

const useStyles = makeStyles((theme) => ({
listItem: {
    padding: theme.spacing(1, 0),
},
total: {
    fontWeight: 700,
},
title: {
    marginTop: theme.spacing(2),
},
}));

export default function ReviewMyVersion({auctionInfo}) {
const classes = useStyles();

// const {
//     title,
//     category,
//     description ,
//     start_date,
//     end_date,
//     budget,
//     volume,
//     move_from_address,
//     move_from_city,
//     move_from_postcode,
//     move_from_country,
//     move_to_address,
//     move_to_city,
//     move_to_postcode,
//     move_to_country,
//     move_on,
//     deliver_on
// } = auctionInfo;

// const auctionSummary = [
//     title,
//     category,
//     description ,
//     start_date,
//     end_date,
//     budget,
//     volume,
//     move_from_address,
//     move_from_city,
//     move_from_postcode,
//     move_from_country,
//     move_to_address,
//     move_to_city,
//     move_to_postcode,
//     move_to_country,
//     move_on,
//     deliver_on
// ]

// const summaryTitle = [
//     'Title:',
//     'Category:',
//     'Description:',
//     'Start date:',
//     'End date:',
//     'Budget:',
//     'Volume:',
//     'Pick up address:',
//     'City',
//     'Zip / Postal code',
//     'Country',
//     'Delivery address',
//     'City',
//     'Zip / Postal code',
//     'Country',
//     'Moving date:',
//     'Delivery date:'
// ]
// console.log(auctionSummary)

return (
    <>
        <Typography variant="h6" gutterBottom>
            Auction summary
        </Typography>

        <Grid container spacing={2}>

            <Grid item xs={12}>
                <Typography variant="body1" className={classes.title}>
                    Auction title:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.title}
                </Typography>
            </Grid>
                
            <Grid item xs={12}>
                <Typography variant="body1" className={classes.title}>
                    Auction category:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.category}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="body1" className={classes.title}>
                    Auction description:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.description}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                    Auction start date:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.start_date}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                    End date:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.end_date}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                    Auction budget:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.budget}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                    Volume:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.volume}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="body1" className={classes.title}>
                    Pick up address:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_from_address}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                City:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_from_city}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                Zip / Postal code:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_from_postcode}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                Country:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_from_country}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="body1" className={classes.title}>
                    Delivery address:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_to_address}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                City:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_to_city}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                Zip / Postal code:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_to_postcode}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <Typography variant="body1" className={classes.title}>
                Moving date:
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.move_on}
                </Typography>
            </Grid>

            <Grid item xs={6}>                
                <Typography variant="body1" className={classes.title}>
                Delivery date: 
                </Typography>
                <Typography variant="subtitle" gutterBottom className={classes.title}>
                    {auctionInfo.deliver_on}
                </Typography>
            </Grid>

        </Grid>
    </>
);
}

//********* LOOK AGAIN AT THIS MAPPING ********* /////
{/* 
        {summaryTitle.map(title => {
                return(
                    <Grid item xs={6} key={summaryTitle}>
                            <Typography variant="body1">
                                {title}:
                            </Typography>
                    </Grid>
                )
            })}   
            {
                auctionSummary && auctionSummary.map(summary => {
                    return(
                        <>
                        <Grid item xs={6} key={auctionSummary}>
                            <Typography variant="subtitle" gutterBottom>
                                {auctionSummary}
                            </Typography>
                        </Grid>
                        </>
                    )
                })
            } */}